import React from 'react'
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Redirect,
    Switch
} from 'react-router-dom'
import Profile from './Profile/Profile'
import AboutMe from '../AboutMe/About'
import Articles from '../Home/Articles/Articles'
import Testimonial from '../Projects/Projects'
import '../../App.css'
import './home.css'

export default function Home() {
    return (
        <div>
            <div className="home-container">
                <Profile />
                {/* <AboutMe />
            <Articles /> */}
            </div>

            <div>

                <div className="container mt-2">

                    <div class="row">
                        <div className="col-md-3 col-sm-6 item">
                            <div class="card item-card card-block">

                                <img src="https://static.pexels.com/photos/7096/people-woman-coffee-meeting.jpg" alt="Photo of sunset" />
                                <h5 className="item-card-title mt-3 mb-3">Sierra Web Development • Owner</h5>
                                <p className="card-text">This is a company that builds websites, web apps and e-commerce solutions.</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 item">
                            <div className="card item-card card-block">

                                <img src="https://static.pexels.com/photos/7357/startup-photos.jpg" alt="Photo of sunset" />
                                <h5 className="card-title  mt-3 mb-3">ProVyuh</h5>
                                <p className="card-text">This is a company that builds websites, web.</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 item">
                            <div className="card item-card card-block">

                                <img src="https://static.pexels.com/photos/262550/pexels-photo-262550.jpeg" alt="Photo of sunset" />
                                <h5 className="card-title  mt-3 mb-3">ProVyuh</h5>
                                <p className="card-text">This is a company that builds websites, web apps and e-commerce solutions.</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 item">
                            <div className="card item-card card-block">

                                <img src="https://static.pexels.com/photos/326424/pexels-photo-326424.jpeg" alt="Photo of sunset" />
                                <h5 className="card-title  mt-3 mb-3">ProVyuh</h5>
                                <p className="card-text">This is a company that builds websites, web apps and e-commerce solutions.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}